import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/page-view-event.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/totaljobs-terms/totaljobs-terms.module.scss");
